import type { ISerialize } from '@/objects/ISerialize';
import { formatDateIso } from '@/utilities/dateutils';

export class DuplicateResult implements ISerialize {
    public ID: number;

    public readonly DOB: Date;

    public readonly Match: number;

    public readonly Name: string | null;

    /***
     * @deprecated Use the static FromJsValues method instead of the constructor to get type safety and default values
     */
    public constructor(values: { ID?: number; DOB?: Date; Match?: number; Name?: string | null }) {
        this.ID = values.ID ?? 0;

        this.DOB = values.DOB ?? new Date('1970-01-01T00:00:00.000');

        this.Match = values.Match ?? 0;

        this.Name = values.Name ?? '';
    }

    public serialize(): string {
        return (
            '{' +
            `"ID": ${JSON.stringify(this.ID)}` +
            ',' +
            `"DOB": ${'"' + formatDateIso(this.DOB).substring(0, 10) + '"'}` +
            ',' +
            `"Match": ${JSON.stringify(this.Match)}` +
            ',' +
            `"Name": ${JSON.stringify(this.Name)}` +
            '}'
        );
    }

    /**
     * Creates an instance of DuplicateResult from the supplied values.
     * Missing values have default values
     * @param values The values you want to set
     * @returns An object instance with the supplied values set
     */
    public static FromJsValues(values: {}): DuplicateResult {
        return new DuplicateResult(values);
    }

    public static _FromServerJson(json: any): DuplicateResult {
        return new DuplicateResult({
            ID: json.ID,
            DOB: json.DOB instanceof Date ? json.DOB : new Date(json.DOB + ' 00:00:00'),
            Match: json.Match,
            Name: json.Name ?? '',
        });
    }

    /**
     * Creates an instance of DuplicateResult from another instance of DuplicateResult.
     * @param other The DuplicateResult you want to clone
     * @returns A cloned DuplicateResult
     */
    public static FromOther(other: DuplicateResult): DuplicateResult {
        return DuplicateResult._FromServerJson(JSON.parse(other.serialize()));
    }

    /**
     * Deepclones the object.
     */
    public DeepClone() {
        return DuplicateResult.FromOther(this);
    }

    static NAME_OF_CLASS = 'DuplicateResult';
}
